export const CSP_QUERY_KEY = 'iframeToken';